import { type Currency, svgIconDataUri } from "@loot-os/api-contract";

/**
 * The environment's currency icon, rendered before an amount.
 *
 * Three cases, decided here so the storefront and the dashboard's preview of it
 * agree: the tenant's uploaded icon when there is one; the historic 💎 glyph
 * for a symbol-less currency with no upload (so "1,250 gems" still reads as a
 * currency); nothing at all for a currency with a symbol, because a glyph in
 * front of "$12.50" is wrong.
 *
 * Rendered as an `<img>` data URI on purpose: tenant-supplied SVG inlined into
 * the DOM would be an XSS hole, and `<img>` runs it in the browser's restricted
 * mode instead. Never swap this for `dangerouslySetInnerHTML` — see
 * api-contract's svgIcon.ts.
 */
export function CurrencyIcon({
  currency,
  className = "size-3.5",
}: {
  currency: Pick<Currency, "symbol" | "iconSvg">;
  className?: string;
}) {
  if (currency.iconSvg) {
    return (
      <img src={svgIconDataUri(currency.iconSvg)} alt="" className={`inline-block ${className}`} />
    );
  }
  if (currency.symbol === "") {
    return (
      <span aria-hidden className="leading-none">
        💎
      </span>
    );
  }
  return null;
}
